export default "__VITE_ASSET__e984d77a__"